import React, { useRef, useState } from 'react'
import { InputGroupPropsTypes } from '../../inputComp/InputGroupType'
import InputGroup from '../../inputComp/InputGroup';
import { APIIcon, TokenIcon } from '../../iconSet/IconSet';
import { APIRequestMessageSetup, APISetupMessage, MessageTypes } from '../../../services/APISetupService';
import useInputValidate from '../../../hooks/useInputValidate';
import AlertDialog from '../../popupComp/AlertDialog';
import LoadingScreen from '../../loadingScreenComp/LoadingScreen';

const Setup = () => {
    // Loading screen
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const {validateField} = useInputValidate()
	
	const [alertDialogState, setAlertDialogState] = useState(false);
	const [alertTitle, setAlertTitle] = useState('');
	const [alertDescription, setAlertDescription] = useState('');
	const [alertCallback, setAlertCallback] = useState<() => void | undefined>();

	const [alertYesCallback, setAlertYesCallback] = useState<(() => void) | undefined>(undefined); // for Yes
    const [alertOkCallback, setAlertOkCallback] = useState<(() => void) | undefined>(undefined);  // for OK

    const showAlertDialog = (title: string, description: string, yesCallback?: () => void, okCallback?: () => void ) => {
        setAlertTitle(title);
        setAlertDescription(description);
        setAlertYesCallback(() => yesCallback);
        setAlertOkCallback(() => okCallback);
        setAlertDialogState(true);
    };

    const whatsappApiRef = useRef<HTMLInputElement | null>(null);
    const whatsappTokenRef = useRef<HTMLTextAreaElement | null>(null);
    const whatsappFrom: InputGroupPropsTypes[] = [
        {
            type: "text",
            icon: <APIIcon width="1.5rem" color="var(--color-main-white)" />,
            color: "var(--color-accent-bg)",
            placeholder: "Enter whatsapp api",
            label: "WhatsApp API",
            name: "departmentid",
            componentInputElement: whatsappApiRef,
            required: true
        },
        {
            type: "text-area",
            icon: <TokenIcon width="1.5rem" color="var(--color-main-white)" />,
            color: "var(--color-accent-bg)",
            placeholder: "Enter whatsapp token",
            label: "WhatsApp token",
            name: "departmentid",
            componentTextArea: whatsappTokenRef,
            required: true
        }
    ]

    const viberApiRef = useRef<HTMLInputElement | null>(null);
    const viberTokenRef = useRef<HTMLTextAreaElement | null>(null);
    const viberFrom: InputGroupPropsTypes[] = [
        {
            type: "text",
            icon: <APIIcon width="1.5rem" color="var(--color-main-white)" />,
            color: "var(--color-accent-bg)",
            placeholder: "Enter viber api",
            label: "Viber API",
            name: "departmentid",
            componentInputElement: viberApiRef,
            required: true
        },
        {
            type: "text-area",
            icon: <TokenIcon width="1.5rem" color="var(--color-main-white)" />,
            color: "var(--color-accent-bg)",
            placeholder: "Enter viber token",
            label: "Viber token",
            name: "departmentid",
            componentTextArea: viberTokenRef,
            required: true
        }
    ]

    const handleSave = async (type: MessageTypes) => {
        if (!whatsappApiRef.current || !whatsappTokenRef.current || !viberApiRef.current || !viberTokenRef.current) return;

        let body: APIRequestMessageSetup | undefined = undefined;

        if (type === 'whatsapp') {
            const whatsappBody: APIRequestMessageSetup = {
                type: type,
                api: whatsappApiRef.current.value,
                token: whatsappTokenRef.current.value
            };
            body = whatsappBody;
        }
        else if (type === 'viber') {
            const viberApiValidity = validateField(viberApiRef);
            const viberTokenValidity = validateField(viberTokenRef);

            if (viberApiValidity && viberTokenValidity) {
                const viberBody: APIRequestMessageSetup = {
                    type: type,
                    api: viberApiRef.current.value,
                    token: viberTokenRef.current.value
                }
                body = viberBody;
            }
        }
        
        try 
        {
            if (body){
                setIsLoading(true);
                const response = await APISetupMessage(body);

                if (response.status)
                {
                    showAlertDialog("Success", "✅ Message data saved successfully", undefined, () => window.location.reload());
                }
                else 
                {
                    showAlertDialog("Error", "❌ Error saving message data");
                }
            }
            else 
            {
                showAlertDialog("Error", "❌ Wrong message type");
            }
            
        }
        catch (error)
        {
            console.error("Error while setting setup with error [ ", error, " ]")
            showAlertDialog("Error", "Error saving message data");
        }
        finally
        {
            setIsLoading(false);
        }
    }

    return (
        <div className={`container-wrapper`}>
			<span className={`title`}>Messaging Configurations</span>
            <div className='setup-wrapper'>
                <div className='container-cat'>
                    <span className='title'>WhatsApp Setup</span>
                    <div className='data-body-wrapper'>
                        {whatsappFrom.map((field, index) => (
                            <InputGroup key={index} {...field} />
                        ))}
                        <div className='button-wrapper'>
                            <button onClick={(e) => {
                                const whatsappApiValidity = validateField(whatsappApiRef);
                                const whatsappTokenValidity = validateField(whatsappTokenRef);
                    
                                if (whatsappApiValidity && whatsappTokenValidity) {
                                    showAlertDialog("Confirm Save", "Are you sure you want to save whatsapp messaging data?", () => handleSave('whatsapp'))
                                }
                            }}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='setup-wrapper'>
                <div className='container-cat'>
                    <span className='title'>Viber Setup</span>
                    <div className='data-body-wrapper'>
                        {viberFrom.map((field, index) => (
                            <InputGroup key={index} {...field} />
                        ))}
                        <div className='button-wrapper'>
                            <button onClick={(e) => {
                                const viberApiValidity = validateField(viberApiRef);
                                const viberTokenValidity = validateField(viberTokenRef);
                    
                                if (viberApiValidity && viberTokenValidity) {
                                    showAlertDialog("Confirm Save", "Are you sure you want to save viber messaging data?", () => handleSave('viber'));
                                }
                            }}>Save</button>
                        </div>
                    </div>
                </div>
            </div>
            {alertDialogState && (
                <AlertDialog
                    title={alertTitle}
                    description={alertDescription}
                    windowState={alertDialogState}
                    setWindowState={setAlertDialogState}
                    function={alertYesCallback}
                    okFunction={alertOkCallback}
                />
            )}
            {isLoading && <LoadingScreen />}
        </div>
    )
}

export default Setup